<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <!-- Main Contributions View -->
    <div class="container-fluid h-100p overflow-y-scroll mycontrib-page-shell">
        <div class="directory-container">
            <!-- Breadcrumb -->
            <div class="breadcrumb-container mb-3">
                <a [routerLink]="['/contact-directory']" class="breadcrumb-link">
                    Back to Directory
                </a>
                <span class="breadcrumb-separator">></span>
                <span class="breadcrumb-current">My Contributions</span>
            </div>

            <!-- Hero -->
            <div class="mycontrib-hero row align-items-center">
                <div class="col-md-6">
                    <div class="mycontrib-hero-left">
                        <div class="mycontrib-user-avatar">DU</div>
                        <div>
                            <h4 class="directory-title text-dblack">My Contributions</h4>
                            <p class="directory-subtitle">
                                Track the status of your submitted contacts and earned credits.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mycontrib-hero-right">
                        <div class="total-credits-section">
                            <span class="total-credits-label">Remaining</span>
                            <i class="fas fa-coins total-credits-icon"></i>
                            <span class="total-credits-value">{{ yourCredits }}</span>
                        </div>
                        <button class="btn btn-success-custom" (click)="onAddContribution()">
                            Add Contribution
                        </button>
                    </div>
                </div>
            </div>

            <!-- Summary Cards Section -->
            <div class="row mb-3">
                <div class="col-md-3 mb-3 mb-md-0">
                    <div class="summary-card">
                        <div class="summary-card-label">Your Rank</div>
                        <div class="summary-card-value">{{ yourRank || '-' }}</div>
                    </div>
                </div>
                <div class="col-md-3 mb-3 mb-md-0">
                    <div class="summary-card">
                        <div class="summary-card-label">Total Credits Earned</div>
                        <div class="summary-card-value">{{ totalCreditsEarned }}</div>
                    </div>
                </div>
                <div class="col-md-3 mb-3 mb-md-0">
                    <div class="summary-card">
                        <div class="summary-card-label">Contributions</div>
                        <div class="summary-card-value">{{ totalContributions }}</div>
                    </div>
                </div>
                <div class="col-md-3 mb-3 mb-md-0">
                    <div class="summary-card">
                        <div class="summary-card-label">Approved Submissions</div>
                        <div class="summary-card-value">{{ approvedSubmissions }}</div>
                    </div>
                </div>
            </div>

            <!-- Filter and Search Section -->
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="mycontrib-toolbar results-controls">
                        <div class="filter-section">
                            <select class="filter-select" [(ngModel)]="selectedFilterType" (ngModelChange)="onFilterTypeChange()">
                                <option *ngFor="let filterType of filterTypes" [value]="filterType.value">
                                    {{ filterType.label }}
                                </option>
                            </select>
                            <div class="filter-input-container">
                                <select *ngIf="selectedFilterType === 'status'" class="filter-select" [(ngModel)]="statusFilter" (ngModelChange)="onStatusFilterChange($event)">
                                    <option value="">All Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>

                                <div class="date-filter-group" *ngIf="selectedFilterType === 'date-added'">
                                    <input class="filter-input date-input" type="date" [(ngModel)]="startDateFilter" (ngModelChange)="onStartDateFilterChange($event)">
                                    <input class="filter-input date-input" type="date" [(ngModel)]="endDateFilter" (ngModelChange)="onEndDateFilterChange($event)">
                                </div>
                            </div>
                        </div>
                        <div class="bulk-actions-section">
                            <div class="contrib-tabs-toggle">
                                <button
                                    class="btn list-toggle-btn"
                                    [class.active]="activeListTab === 'contributions'"
                                    (click)="setActiveListTab('contributions')"
                                >
                                    Contributions
                                </button>
                                <button
                                    class="btn list-toggle-btn"
                                    [class.active]="activeListTab === 'update_requests'"
                                    (click)="setActiveListTab('update_requests')"
                                >
                                    Update Requests
                                </button>
                            </div>

                            <button
                                class="btn bulk-delete-btn"
                                *ngIf="activeListTab === 'contributions'"
                                (click)="onBulkDelete()"
                                [disabled]="getSelectedContributions().length === 0"
                            >
                                Bulk Delete
                                <span *ngIf="getSelectedContributions().length > 0" class="badge ms-2">
                                    {{ getSelectedContributions().length }}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Loading State -->
            <div class="row" *ngIf="isLoading">
                <div class="col-12 text-center py-5">
                    <div class="spinner-border text-secondary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="text-muted mt-2">Loading contributions...</p>
                </div>
            </div>

            <!-- Table -->
            <div class="row" *ngIf="!isLoading">
                <div class="col-12">
                    <div class="table-responsive dark-table-container mycontrib-table-container">
                        <table class="table table-dark table-hover directory-table mycontrib-table">
                            <thead>
                                <tr>
                                    <th class="checkbox-column" *ngIf="activeListTab === 'contributions'">
                                        <input type="checkbox" class="table-checkbox" [checked]="selectAll" (change)="toggleSelectAll($event)">
                                    </th>
                                    <th>Organization Name</th>
                                    <th>Officer Name</th>
                                    <th>Operator Type</th>
                                    <th>{{ activeListTab === 'contributions' ? 'Date Submitted' : 'Requested On' }}</th>
                                    <th>Status</th>
                                    <th *ngIf="activeListTab === 'contributions'">Total Credits</th>
                                    <th *ngIf="activeListTab === 'contributions'">Actions</th>
                                    <th *ngIf="activeListTab === 'update_requests'">Request Reason</th>
                                    <th *ngIf="activeListTab === 'update_requests'">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let contribution of activeListTab === 'contributions' ? contributions : updateRequests">
                                    <td class="checkbox-column" *ngIf="activeListTab === 'contributions'">
                                        <input type="checkbox" class="table-checkbox" [checked]="contribution.selected" (change)="toggleContributionSelection(contribution)">
                                    </td>
                                    <td>{{ contribution.organizationName }}</td>
                                    <td>{{ contribution.officerName }}</td>
                                    <td>{{ contribution.operatorType }}</td>
                                    <td>{{ contribution.dateSubmitted }}</td>
                                    <td>
                                        <span [class]="getStatusClass(contribution.status)">
                                            <i class="fas fa-check-circle" *ngIf="contribution.status?.toLowerCase() === 'approved'"></i>
                                            {{ contribution.status | titlecase }}
                                        </span>
                                    </td>
                                    <td *ngIf="activeListTab === 'contributions'">
                                        <span class="credits-value" *ngIf="contribution.creditsEarned > 0">
                                            +{{ contribution.creditsEarned }}
                                        </span>
                                        <span *ngIf="contribution.creditsEarned === 0">0</span>
                                    </td>
                                    <td *ngIf="activeListTab === 'contributions'">
                                        <div class="action-icons">
                                            <i class="fas fa-edit edit-icon" (click)="onEditContribution(contribution)" title="Edit"></i>
                                            <i class="fas fa-trash delete-icon" (click)="onDeleteContribution(contribution)" title="Delete"></i>
                                        </div>
                                    </td>
                                    <td *ngIf="activeListTab === 'update_requests'">
                                        <span [title]="contribution.rejectionReason">
                                            {{ contribution.rejectionReason || 'N/A' }}
                                        </span>
                                    </td>
                                    <td *ngIf="activeListTab === 'update_requests'">
                                        <button
                                            type="button"
                                            class="btn btn-sm cancel-update-btn"
                                            *ngIf="canCancelUpdateRequest(contribution)"
                                            [disabled]="cancellingUpdateRequestId === contribution.updateRequestId"
                                            (click)="openCancelUpdateRequestModal(contribution)"
                                        >
                                            <span *ngIf="cancellingUpdateRequestId !== contribution.updateRequestId">Cancel</span>
                                            <span *ngIf="cancellingUpdateRequestId === contribution.updateRequestId" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        </button>
                                        <span *ngIf="!canCancelUpdateRequest(contribution)" class="text-muted small">—</span>
                                    </td>
                                </tr>
                                <tr *ngIf="(activeListTab === 'contributions' ? contributions.length : updateRequests.length) === 0">
                                    <td [attr.colspan]="activeListTab === 'contributions' ? 8 : 7" class="text-center py-4">
                                        <p class="text-muted mb-0 empty-state-text">
                                            {{ activeListTab === 'contributions' ? 'No contributions found' : 'No update requests found' }}
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Pagination -->
            <div class="row justify-content-center" *ngIf="!isLoading">
                <div class="col-auto">
                    <app-paginator [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" (pageChange)="onPageChange($event)">
                    </app-paginator>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal fade" id="deleteContributionModal" tabindex="-1" aria-labelledby="deleteContributionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content dark-modal-content">
            <div class="modal-header dark-modal-header">
                <h5 class="modal-title" id="deleteContributionModalLabel">
                    <span *ngIf="!isBulkDelete">Request Deletion</span>
                    <span *ngIf="isBulkDelete">Bulk Delete Request</span>
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" [disabled]="isDeleting"></button>
            </div>
            <div class="modal-body dark-modal-body">
                <p class="mb-3" *ngIf="!isBulkDelete">
                    Are you sure you want to request deletion for this contribution?
                </p>
                <p class="mb-3" *ngIf="isBulkDelete">
                    Are you sure you want to request deletion for <strong>{{ getSelectedContributionsForDelete().length }}</strong> selected contribution(s)?
                </p>

                <div class="contribution-details mb-3" *ngIf="!isBulkDelete">
                    <div class="detail-item">
                        <span class="detail-label">Organization:</span>
                        <span class="detail-value">{{ selectedContributionForDelete?.organizationName || 'N/A' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Officer Name:</span>
                        <span class="detail-value">{{ selectedContributionForDelete?.officerName || 'N/A' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Operator Type:</span>
                        <span class="detail-value">{{ selectedContributionForDelete?.operatorType || 'N/A' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Date Submitted:</span>
                        <span class="detail-value">{{ selectedContributionForDelete?.dateSubmitted || 'N/A' }}</span>
                    </div>
                </div>

                <div class="contribution-details mb-3" *ngIf="isBulkDelete">
                    <div class="selected-items-list">
                        <p class="mb-2"><strong>Selected Contributions:</strong></p>
                        <div class="selected-item" *ngFor="let contribution of getSelectedContributionsForDelete()">
                            <span class="item-name">{{ contribution.organizationName }} - {{ contribution.officerName }}</span>
                        </div>
                    </div>
                </div>

                <div class="form-group-custom">
                    <label for="requestReason" class="form-label">
                        Reason for Deletion Request <span class="required">*</span>
                    </label>
                    <textarea class="form-control dark-input" id="requestReason" [(ngModel)]="deletionRequestReason" name="requestReason" rows="4" placeholder="Please provide a reason for deletion request..." required [disabled]="isDeleting"></textarea>
                </div>
            </div>
            <div class="modal-footer dark-modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" [disabled]="isDeleting">
                    Cancel
                </button>
                <button type="button" class="btn btn-danger" (click)="confirmDelete()" [disabled]="isDeleting || !deletionRequestReason || deletionRequestReason.trim() === ''">
                    <span *ngIf="!isDeleting">Submit Request</span>
                    <span *ngIf="isDeleting">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Submitting...
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Cancel update request confirmation -->
<div class="modal fade" id="cancelUpdateRequestModal" tabindex="-1" aria-labelledby="cancelUpdateRequestModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content dark-modal-content">
            <div class="modal-header dark-modal-header">
                <h5 class="modal-title" id="cancelUpdateRequestModalLabel">Cancel update request</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" [disabled]="cancellingUpdateRequestId === pendingCancelUpdateRequestRow?.updateRequestId"></button>
            </div>
            <div class="modal-body dark-modal-body">
                <p class="mb-3">Are you sure you want to cancel? This will withdraw your pending update request.</p>
                <div class="contribution-details mb-0" *ngIf="pendingCancelUpdateRequestRow">
                    <div class="detail-item">
                        <span class="detail-label">Organization:</span>
                        <span class="detail-value">{{ pendingCancelUpdateRequestRow.organizationName || 'N/A' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Officer Name:</span>
                        <span class="detail-value">{{ pendingCancelUpdateRequestRow.officerName || 'N/A' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">Operator Type:</span>
                        <span class="detail-value">{{ pendingCancelUpdateRequestRow.operatorType || 'N/A' }}</span>
                    </div>
                </div>
            </div>
            <div class="modal-footer dark-modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" [disabled]="cancellingUpdateRequestId === pendingCancelUpdateRequestRow?.updateRequestId">
                    No, keep request
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    (click)="confirmCancelUpdateRequest()"
                    [disabled]="cancellingUpdateRequestId === pendingCancelUpdateRequestRow?.updateRequestId"
                >
                    <span *ngIf="cancellingUpdateRequestId !== pendingCancelUpdateRequestRow?.updateRequestId">Yes, cancel request</span>
                    <span *ngIf="cancellingUpdateRequestId === pendingCancelUpdateRequestRow?.updateRequestId">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Cancelling…
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>